import { lazy, Suspense, useState } from "react";

const FAQModal = lazy(() =>
  import("./FAQModal").then((m) => ({ default: m.FAQModal }))
);

interface FAQModalLazyProps {
  children: React.ReactNode;
}

/**
 * Lazy wrapper for FAQModal — loads the component only after first user click,
 * keeping ~11KB out of the initial bundle.
 */
export const FAQModalLazy = ({ children }: FAQModalLazyProps) => {
  const [loaded, setLoaded] = useState(false);

  if (!loaded) {
    return (
      <span
        onClick={() => setLoaded(true)}
        onMouseEnter={() => setLoaded(true)}
        onTouchStart={() => setLoaded(true)}
      >
        {children}
      </span>
    );
  }

  return (
    <Suspense fallback={<span>{children}</span>}>
      <FAQModal>{children}</FAQModal>
    </Suspense>
  );
};
